import React, { useEffect, useState, useRef } from 'react';

import images from '../libs/images';
import consts from '../libs/consts';

import { clickDownS3, getFileName, regFileDoc, regFileImage } from '../utils/utils';

import Button from './Button';
import Image from './Image';

import { toast } from 'react-toastify';

export default function InputFile(props) {

    const { 
        className, 
        placeholder, 
        type, 
        title,
        deleteTitle,
        name, 
        maxlength, 
        value, 
        setValue, 
        setExt,
        setFileName,
        defaultFileName, 
        onChange,
        fileNameView=true,
        valid, 
        label, 
        labelLeft,
        labelType='image',
        error, 
        setError,
        success, 
        readOnly, 
        onBlur,
        withButton, 
        withButtonPress,
        style,
        down=false,
        fileDeleteButton=false,
        onDelete
    } = props;
    
    const fileInput = useRef();
    const [cker, setCker] = useState(false);
    const [detailImageUrl, setDetailImageUrl] = useState("");
    const [file_name, setfile_name] = useState("");

    useEffect(() => {

        setDetailImageUrl(defaultFileName)
        
    }, [defaultFileName]);

    const handleChange = ({ file }) => {

        if(setError) setError('');

        var reg = "";
        var msg = "";

        if(valid === 'image') {
            reg = regFileImage;
            msg = "이미지";
        } else if(valid === 'doc') {
            reg = regFileDoc;
            msg = "문서";
        }

        if(file.name.toLowerCase().match(reg)) {
            console.log(file);
            setfile_name(file.name);

            if(setFileName) setFileName(file.name);
            
            let reader = new FileReader();
            reader.onload = function () {

                let fn = file.name.split('.');

                if(onChange) {

                    onChange(reader.result, fn[fn.length-1]);

                } else {
                    setDetailImageUrl(reader.result);
                    setValue({
                        base: reader.result, 
                        ext: fn[fn.length-1]
                    });
                    setCker(true);

                    if(setExt) {
                        setExt(fn[fn.length-1]);
                    }
                }

            };
            reader.readAsDataURL(file);
            fileInput.current.value = "";
    
        } else {

            fileInput.current.value = "";
            setCker(false);

            if(!onChange) {
                setValue("");
                setDetailImageUrl("");
                setfile_name("");

                if(setFileName) setFileName("");
                if(setExt) {
                    setExt('');
                }
            }
            
            toast.error(
                msg === '문서' ? '지원하지 않는 파일형식 입니다.' 
                : "이미지 파일만 업로드 가능합니다."
                , consts.toastErrorOption
            );

            // dispatch(
            //     open({
            //         message: msg + " 파일만 업로드 가능합니다.",
            //     })
            // );
           
        }
       
    };

    // set file reader function
    const fileDelete = () => {
        if(!readOnly) {
            fileInput.current.value = "";
            setCker(false);
            setValue("");
            setDetailImageUrl("");
            setfile_name("");

            onDelete && onDelete();
        }
    };
   
    return (
        <div className="input_box" style={style}>

            {label && <p className="input_label">{label}</p>}

            <div className="input_file_section">

                {labelType === 'image' ? (
                    <label className={`input_file_label ${detailImageUrl ? 'input_file_label_img' : ''}`} htmlFor={!readOnly ? name : ""}>
                        {!detailImageUrl ? (
                            <>
                                <Image className={['input_null_img']} src={images.profile} />
                                <p className='btn btn2'>{title}</p>
                            </>
                        ) : (
                            <>
                                <Image className={['input_preview_img']} src={detailImageUrl ? detailImageUrl : images.photo} />
                                <p className='btn btn2' onClick={(e) => {e.preventDefault(); fileDelete();}} >{deleteTitle}</p>
                                {/* <button className={'input_preview_button '} onClick={(e) => {e.preventDefault(); fileDelete();}} /> */}
                            </>
                        )}
                        
                    </label>
                ) : (
                    <div className="input_file_label_doc">
                        <label className={"btn btn4 btn_round"} htmlFor={!readOnly ? name : ""}>
                            <img src={images.upload}/>
                            업로드
                        </label>
                        {(file_name && fileNameView) && (
                            <p>{file_name}</p>
                        )}

                        {(value && fileDeleteButton) && (
                            <button className="delete_btn" style={{marginLeft: 10}} onClick={() => fileDelete()}/>
                        )}
                    </div>
                )}
                
                
                <input 
                    ref={fileInput}
                    type={type} 
                    name={name} 
                    id={name} 
                    onChange={({ target: { files } }) => {
                        if (files.length) {
                            handleChange({
                                file: files[0]
                            })
                        }
                    }} />    
            </div>

            {error && 
                <p className="input_error animate__animated animate__headShake">{error}</p>
            }
            {success && 
                <p className="input_success">{success}</p>    
            }
        </div>
    )    
}